


































































































































































































































































































































































// Vue
import Vue, { PropType } from "vue";
// moment.js
import moment from "moment";
// Constants
import {
  DeliveryDateType,
  deliveryDateType_getDisplayText
} from "@/core/_constants/deliveryDateTypes.constant";
import { JobType, jobType_getDisplayText } from "@/core/_constants/jobTypes.constant";
import { quantityType_getDisplayText } from "@/core/_constants/quantityTypes.constant";

// Models
import {
  DriverModel,
  JobModel,
  JobDriverModel,
  JobDriverStatus,
  JobApplicationModel
} from "@/core/api/apiClient";
//import { IQuarryAssignment } from "@/core/_models/quarryAssignment.model";

// Components
import UpdateJobDialog from "@/views/dispatch/jobs/job-dashboard/_dialogs/UpdateJobDialog.vue";
import ConfirmationDialog from "@/core/components/content/_dialogs/ConfirmationDialog.vue";
import ExportJob from "@/core/components/content/ExportJob.vue";
import AssignQuarries from "@/views/admin/_dialogs/quarries/AssignQuarries.vue";

export default Vue.extend({
  name: "JobCard",
  components: {
    UpdateJobDialog,
    ConfirmationDialog,
    ExportJob,
    AssignQuarries
  },
  props: {
    job: Object as PropType<JobModel>,
    drivers: Array as PropType<JobDriverModel[]>,
    isViewing: Boolean
  },
  data() {
    return {
      JobDriverStatus: JobDriverStatus // <-- expose enum
    };
  },
  mounted() {
    // console.log("this.job", this.job);
  },
  computed: {
    selectedDrivers: {
      get(): DriverModel[] {
        return this.job.drivers.map(
          (jobDriver: JobDriverModel) =>
            new DriverModel({
              driverId: jobDriver.driverId,
              firstName: jobDriver.firstName,
              lastName: jobDriver.lastName,
              userId: jobDriver.userId
            })
        );
      },
      set(selectedDrivers: DriverModel[]) {
        const existingDriversMap = new Map(this.job.drivers.map((d) => [d.driverId, d]));

        this.job.drivers = selectedDrivers.map((driver) => {
          const existing = existingDriversMap.get(driver.driverId);

          if (existing) {
            return existing;
          } else {
            return new JobDriverModel({
              jobDriverId: "",
              driverId: driver.driverId,
              firstName: driver.firstName,
              lastName: driver.lastName,
              userId: driver.userId,
              quarry: undefined
            });
          }
        });
      }
    }
  },

  methods: {
    refreshJobs(): void {
      this.$emit("refresh-jobs");
    },

    updateJob(): void {
      this.$emit("update-job", this.job);
    },

    deleteJob(): void {
      this.$emit("delete-job", this.job);
    },

    cancelJob(): void {
      this.$emit("cancel-job", this.job);
    },

    completeJob(): void {
      this.$emit("complete-job", this.job);
    },

    /**
     * Resturns the Status for a Driver in the job.Drivers array
     * @author Justin Blackwell & Nick Brahimir
     */
    getIconDriverStatus(jobDrivers: JobDriverModel[], driverId: string): JobDriverStatus | undefined {
      const result = jobDrivers.filter((x) => x.driverId === driverId)[0].status;
      return result;
    },

    /**
     * Removes a Driver from the respective array of Drivers on a Job.
     * @author Nick Brahimir
     */
    removeDriver(driverArray: JobDriverModel[], driver: DriverModel): JobDriverModel[] {
      const index = driverArray.map((e) => e.driverId).indexOf(driver.driverId);

      if (index >= 0) {
        driverArray.splice(index, 1);
        return driverArray;
      }

      return driverArray;
    },

    hasNotes(job: JobModel): boolean {
      if (job.deliveryDetails) if (job.deliveryDetails.notes) return true;
      if (job.driverNotes) if (job.driverNotes.length > 0) return true;
      return false;
    },

    hasImages(job: JobModel): boolean {
      if (job.jobImages) if (job.jobImages.length > 0) return true;
      return false;
    },

    hasPrice(job: JobModel): boolean {
      if (job.deliveryDetails?.price) return true;
      return false;
    },

    isDumpJob(job: JobModel): boolean {
      if (JobType[job.jobType] === JobType.Dump) return true;
      return false;
    },

    isPumpJob(job: JobModel): boolean {
      if (JobType[job.jobType] === JobType.Pump) return true;
      return false;
    },

    isToday(date: any): boolean {
      // ? Convert the Unix timestamp
      const incomingDate = moment(date.seconds * 1000).startOf("day");
      const dateToday = moment(new Date()).startOf("day");

      return incomingDate.isSame(dateToday);
    },

    isTomorrow(date: any): boolean {
      // ? Convert the Unix timestamp
      const incomingDate = moment(date.seconds * 1000).startOf("day");
      const dateToday = moment(new Date()).startOf("day");

      return incomingDate.isSame(dateToday.add(1, "days"));
    },

    isYesterday(previousJob: JobModel, currentJob: JobModel): boolean {
      // ? Convert the Unix timestamp
      const currentDate = moment(currentJob.deliveryDetails?.deliveryDate).startOf("day");
      const previousDate = moment(previousJob.deliveryDetails?.deliveryDate).startOf("day");

      if (currentDate.isSame(previousDate)) {
        return true;
      }

      return false;
    },

    displayDeliveryDateType(deliveryDateType: string): string | undefined {
      return deliveryDateType_getDisplayText(deliveryDateType);
    },

    displayJobType(jobType: string): string | undefined {
      return jobType_getDisplayText(jobType);
    },

    displayQuantityType(quantityType: string): string | undefined {
      return quantityType_getDisplayText(quantityType);
    },

    applicationName(application: JobApplicationModel): string {
      return application.customName || (application.application && application.application.name) || "";
    },

    isRedText(deliveryDateType: string): boolean {
      switch (DeliveryDateType[deliveryDateType]) {
        case DeliveryDateType.NotConfirmed:
          return true;

        case DeliveryDateType.WillCall:
          return true;

        case DeliveryDateType.Anytime:
          return true;

        case DeliveryDateType.ASAP:
          return true;

        default:
          return false;
      }
    }
  },

  filters: {
    moment: function (date: any) {
      try {
        return moment(date.toDate()).format("MMMM Do, YYYY");
      } catch {
        try {
          return moment(date).format("MMMM Do, YYYY");
        } catch {
          return "";
        }
      }
    },

    momentDateTime: function (date: any) {
      try {
        return moment(date.toDate()).format("dddd, MMMM Do YYYY");
      } catch {
        try {
          return moment(date).format("dddd, MMMM Do YYYY");
        } catch {
          return "";
        }
      }
    },

    momentTime: function (date: any) {
      try {
        return moment(date.toDate()).format("h:mm A");
      } catch {
        try {
          return moment(date).format("h:mm A");
        } catch {
          return "";
        }
      }
    }
  }
});
